import { TextField } from '@UI/index';
import { validateUrl } from '@store/calendar/calendarHelper';
import { Button } from '@mui/material';
import { Modal } from '@kathondvla/react-shared-components/src/components';
import { useState } from 'react';

import AddBoxIcon from '@mui/icons-material/AddBox';
import './addAttachmentModals.scss';

const AddLinkModal = ({ onConfirm, onClose }) => {
  const [attachment, setAttachment] = useState({ description: '', href: '' });
  const isInvalidUrl = attachment.href.trim() !== '' && !validateUrl(attachment.href.trim());
  const urlError = isInvalidUrl ? { message: 'Ongeldige URL' } : null;
  const valid = !isInvalidUrl && attachment.href.trim() !== '' && attachment.description.trim() !== '';

  const onAddHandler = () => {
    onConfirm?.({
      file: null,
      type: 'link',
      href: attachment.href.trim(),
      name: attachment.description.trim(),
      description: attachment.description.trim(),
      uploaded: false,
    });
  };

  return (
    <>
      <Modal.Header title="Een link toevoegen" onClose={onClose} />
      
      <Modal.Body>
        <div className="add-attachment-modal">
          <div className="link-wrapper">
            <div className="att-title">
              <label className="label">
                Titel:
                <TextField
                  value={attachment.description}
                  onChange={(val) => setAttachment((prev) => ({ ...prev, description: val }))}
                />
              </label>
            </div>
            <div className="att-url">
              <label className="label">
                Link:
                <TextField
                  value={attachment.href}
                  error={urlError}
                  onChange={(val) => setAttachment((prev) => ({ ...prev, href: val }))}
                />
              </label>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outlined" onClick={onClose}>
          Annuleren
        </Button>
        <Button
          variant="contained"
          startIcon={<AddBoxIcon />}
          disabled={!valid}
          onClick={onAddHandler}
        >
          Voeg toe
        </Button>
      </Modal.Footer>
    </>
  );
};

export default AddLinkModal;